<div>
  <div class="profile-container">
    <div class="profile-card">
      <div class="profile-header">
        <div
          class="profile-img-wrapper"
          (click)="onLogoClick()"
          title="Click to change logo"
        >
          <img
            [src]="user?.photoURL || './../../../assets/avatar.png'"
            class="profile-img"
            alt="Profile Logo"
          />
          <div class="overlay">
            <span class="material-icons">edit</span>
          </div>
          <input
            type="file"
            id="logoInput"
            style="display: none"
            (change)="onFileSelected($event)"
            accept="image/*"
          />
        </div>
        <div class="profile-details">
          <h3>{{ user.displayName }}</h3>
          <p *ngIf="user?.accountdetails?.companyname">
            {{ user.accountdetails.companyname }}
          </p>
          <p *ngIf="user.city">{{ user.city }},{{ user.state }}</p>
        </div>
        <div class="buttonholder">
          <button class="edit-btn" (click)="editprofiledetails()">Edit</button>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h4>Personal Information</h4>
          <button class="edit-btn" (click)="editprofiledetails()">Edit</button>
        </div>
        <div class="section-content">
          <div class="row">
            <div class="col">
              <label>First Name</label>
              <p>{{ user.firstname }}</p>
            </div>
            <div class="col">
              <label>Last Name</label>
              <p>{{ user.lastname }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label>Email Address</label>
              <p>{{ user.emailid }}</p>
            </div>
            <div class="col" *ngIf="user.phoneNumber">
              <label>Phone</label>
              <p>{{ user.phoneNumber }}</p>
            </div>
          </div>
          <div class="row" *ngIf="user.address1">
            <div class="col">
              <label>Address</label>
              <p>{{ user.address1 }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h4>Company info</h4>
          <button class="edit-btn" (click)="editCompanydetails()">Edit</button>
        </div>
        <div class="section-content">
          <!-- row1 -->

          <div class="row">
            <div class="col">
              <label>Company name</label>
              <p>{{ user.accountdetails.companyname }}</p>
            </div>
            <div class="col" *ngIf="user.accountdetails?.companyfoundyear">
              <label>Started year</label>
              <p>{{ user.accountdetails.companyfoundyear }}</p>
            </div>
            <div class="col" *ngIf="user.accountdetails?.officeemailid">
              <label>Email</label>
              <p>{{ userdetails.accountdetails.officeemailid }}</p>
            </div>
          </div>
          <!-- row2 -->

          <div class="row">
            <div class="col" *ngIf="user.accountdetails?.officeaddress">
              <label>Address</label>
              <p>{{ userdetails.accountdetails.officeaddress }}</p>
            </div>
            <!--   
              <div
                class="col"
               
              >
                <label *ngIf="userdetails.accountdetails
                        .companyservice?.length>0">Service</label>
                <ng-container *ngIf="userdetails.businesstype == 'contract'">
                  <div
                    *ngFor="
                      let item of userdetails.accountdetails
                        .companyservice
                    "
                  >
                    <span
                      style="font-size: 12px; color: #333; font-weight: bold"
                      >{{ item }}</span
                    >
                  </div>
                </ng-container>
  
                <ng-container *ngIf="userdetails.businesstype !== 'contract'">
                  <div>
                    <span
                      style="font-size: 12px; color: #333; font-weight: bold"
                      >{{
                        userdetails.accountdetails.companyservice
                      }}</span
                    >
                  </div>
                </ng-container>
              </div> -->
          </div>

          <!-- row3 -->
          <div class="row" *ngIf="userdetails.accountdetails.officephone">
            <div class="col">
              <label>Phone Number</label>
              <p>{{ userdetails.accountdetails.officephone }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
